import { useNavigate } from 'react-router-dom';
import { Button } from '@newcore/ui/buttons';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Sizes } from '@newcore/ui/enums/sizes';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';
import { Text } from '@newcore/ui/typography';
import errorImage from '@/assets/error-image.svg';
import { LogoVertical } from '@/components/logos';
import { Page } from '@/components/ui/page';
import { makeFullPath } from '@/utils/path-utils';

export default function RequestErrorPage() {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate(makeFullPath('/login'));
  };

  return (
    <Page className='flex flex-col justify-center items-center'>
      <div className='flex flex-col items-center gap-1 text-center relative'>
        <LogoVertical className='absolute -top-36 left-1/2 -translate-x-1/2 ' />

        <img src={errorImage} alt='Request Error' className='mb-4' />

        <Text as='h1' size={TextSizes.MD} weight={FontWeights.BOLD}>
          Something went wrong
        </Text>

        <Text as='p' size={TextSizes.MD} className='text-secondary'>
          There was a problem with this request.
        </Text>
      </div>

      <div className='flex flex-col sm:flex-row gap-3 w-full sm:w-auto mt-10'>
        <Button
          variant={ButtonVariants.PRIMARY}
          size={Sizes.MD}
          onClick={handleBackToLogin}
          className='min-w-[140px]'
        >
          Back to Login
        </Button>
      </div>
    </Page>
  );
}
